import { Link } from "react-router-dom";

import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { SoftwareInventoryReport } from "@/features/servers/components/SoftwareInventoryReport";

/**
 * Reporte global de inventario de software (no atado a un centro).
 */
export default function ServersReportPage() {
  return (
    <div className="space-y-4">
      <nav
        className="flex items-center gap-2 text-sm text-muted-foreground print:hidden"
        aria-label="Navegación"
      >
        <Button variant="ghost" size="sm" className="cursor-pointer -ml-2" asChild>
          <Link to="/users">
            <ArrowLeft className="h-4 w-4 mr-1" aria-hidden />
            Usuarios
          </Link>
        </Button>
        <span aria-hidden>/</span>
        <span className="text-foreground font-medium">Inventario</span>
      </nav>
      <SoftwareInventoryReport />
    </div>
  );
}
